import { gql } from "@apollo/client";

import { MEMBER_INFO, TRANSACTION_INFO } from "../fragments";

export const MEMBER_PROFILE = gql`
  query myProfile {
    myProfile {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const BANK_LIST = gql`
  query banks {
    banks {
      id
      bankName
      bankNameEng
      imageUrl
    }
  }
`;

export const TRANSACTION_RECORD = gql`
  query memberFundRecord {
    memberFundRecord {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const INVESTMENT_PROFIT = gql`
  query memberInvestmentProfit {
    memberInvestmentProfit {
      profit
      investResult
    }
  }
`;
